import React, {useContext, useEffect} from 'react';
import CommandsContext from '../../../../../context/commandsContext';
import MenuContext from '../../../../../context/menuContext';
import useKeyPress from '../../../../../hooks/useKeyPress';
import BodyContentView from '../../../../views/bodyContentView';
import {useMenu, findParent} from '../../../../../hooks/useMenu';

function LoopCurrent({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const rightPress = useKeyPress('ArrowRight');
  const {onUpdateCommands} = useContext(CommandsContext);
  const {selected, items} = useMenu();

  const parent = findParent(null, items, selected);
  useEffect(() => {
    if (!leftPress) return;
    onExit();
  }, [leftPress]);

  useEffect(() => {
    if (!rightPress) return;

    onExit();
  }, [rightPress]);

  useEffect(() => {
    setTimeout(() => {
      onUpdateCommands({onLeft: onExit, onRight: onExit});
    });
  }, [onExit]);

  return <BodyContentView title={selected.name} left="Cancel" right="Fixed" caption="" />;
}

export default LoopCurrent;
